import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { displayAlert } from "../store/actions/alert";
import Logout from "../components/authentication/logout";

function useNetworkInterceptor() {
    const dispatch = useDispatch();
    const logout = Logout({
        render: (logoutHandler) => {
            return logoutHandler;
        },
    });
    useEffect(() => {
        axios.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                if (error.config.skipErrorMsg) {
                    error = {};
                }
                return Promise.reject(error);
            },
        );
    }, []);

    return null;
}

export default useNetworkInterceptor;
